import { render, staticRenderFns } from "./UsuarioEditar.vue?vue&type=template&id=2cb9f0c0&"
import script from "./UsuarioEditar.vue?vue&type=script&lang=js&"
export * from "./UsuarioEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports